<template>
  <div class="sign-in-container">
    <div class="mainWrapper">
      <div class="login-panel-left">
        <div class="login-panel-left-img"></div>
      </div>
      <div class="loginTabWrapper">
        <registerForm></registerForm>
      </div>
    </div>
  </div>
</template>

<script>
import registerForm from './components/registerForm'

export default {
  data () {
    return {}
  },
  components: {
    registerForm
  }
}
</script>

<style lang="scss" scoped>
.sign-in-container {
  .mainWrapper {
    position: absolute;
    // top: 168px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    width: 1000px;
    padding: 85px 0 59px 134px;
    background: #fff;
    // margin-left: -500px;
    z-index: 1;
    border-radius: 6px;
  }
  .loginTabWrapper {
    height: 404px;
    padding: 0 0 0 112px;
    // padding-bottom: 46px;
    background-color: #fff;
  }

  .login-panel-left {
    position: relative;
    background: #fff;
    .login-panel-left-img {
      width: 304px;
      height: 402px;
      background: url(https://fe-cdn.mofaxiao.com/cactus-portal/static/img/bg-login-panel-left.png)
        no-repeat;
      background-size: cover;
    }
    &:before {
      content: "Hello";
      position: absolute;
      top: -30px;
      left: -45px;
      font-size: 66px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #2d5bff;
      height: 66px;
      line-height: 66px;
    }
  }
}
</style>
